<header class="redefine-header">
    <div class="header-container">
        <div class="header-left">
            <a routerLink="/" class="logo">
                <img src="/assets/whitelabel/redefine/logo.png" alt="Redefine Properties" />
            </a>
            <!-- Admin/Enterprise Manager access - next to logo -->
            <a *ngIf="authService.isAdmin || authService.isEnterpriseManager" (click)="goToAdmin()" class="nav-link nav-link--admin">Admin</a>
        </div>
        <nav class="header-nav">
            <a routerLink="/" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Home</a>
            <a routerLink="/map-search" class="nav-link" routerLinkActive="active">Find Parking</a>
            <a routerLink="/contact" class="nav-link" routerLinkActive="active">Contact</a>
        </nav>
        <div class="header-actions">
            <!-- Profile dropdown for logged in users -->
            <div class="profile-dropdown" *ngIf="authService.uid && !authService.isAnonymous">
                <button class="profile-btn" (click)="toggleProfileMenu()">
                    <i class="fa-solid fa-user"></i>
                    <i class="fa-solid fa-chevron-down"></i>
                </button>
                <div class="profile-menu" *ngIf="profileMenuOpen">
                    <a [routerLink]="['/client', authService.uid]" class="menu-item" (click)="profileMenuOpen = false">
                        <i class="fa-solid fa-user"></i> Profile
                    </a>
                    <a routerLink="/merchant/portfolios" class="menu-item" (click)="profileMenuOpen = false">
                        <i class="fa-solid fa-briefcase"></i> Landlord Profile
                    </a>
                    <hr class="menu-divider" />
                    <a (click)="signOut()" class="menu-item">
                        <i class="fa-solid fa-sign-out-alt"></i> Log Out
                    </a>
                </div>
            </div>
            
            <!-- Sign In link for non-logged in users -->
            <a *ngIf="!authService.uid || authService.isAnonymous" routerLink="/sign-in" class="nav-link">Sign In</a>
        </div>
    </div>
</header>
